export default "__VITE_ASSET__D9JOI_W2__"